// macOS takes ⌘ for shortcuts; Windows and Linux take Ctrl. Read once: the platform cannot change mid-session.
const isMacPlatform =
  typeof navigator !== 'undefined' &&
  /mac|iphone|ipad/i.test(
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform
  )

/** The modifier key as a keycap reads it: `⌘` on a Mac, `Ctrl` elsewhere. */
export const MODIFIER_LABEL = isMacPlatform ? '⌘' : 'Ctrl'

/** The same key as `aria-keyshortcuts` names it. */
export const MODIFIER_ARIA = isMacPlatform ? 'Meta' : 'Control'

/** Whether the platform's shortcut modifier is held: ⌘ on a Mac, Ctrl elsewhere, never both. */
export const isModifierHeld = (event: KeyboardEvent): boolean => (isMacPlatform ? event.metaKey : event.ctrlKey)

/** A key pressed in a field belongs to the field, not to a page shortcut. */
export const isTypingTarget = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement &&
  (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))
